import { useCallback, useContext } from "react";
import { AmplitudeContext } from "@/providers/AmplitudeProvider/AmplitudeProvider";

const useAmplitude = () => {
  const amplitude = useContext(AmplitudeContext);

  const trackEvent = useCallback(
    (eventName: string, eventProperties?: Record<string, any>) => {
      amplitude.track(eventName, eventProperties);
    },
    [amplitude]
  );

  return { trackEvent };
};

export default useAmplitude;
